import * as actionTypes from 'store/actionTypes';

const INITIAL_STATE = {
  theme: 'light',
  showNavigation: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_THEME:
      return {
        ...state,
        theme: action.payload.theme,
      };

    case actionTypes.SHOW_NAVIGATION:
      return {
        ...state,
        showNavigation: action.payload,
      };

    default:
      return state;
  }
};
